var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-group',_vm._l((_vm.lineAssets),function(asset){return _c('asset',{key:asset.assetID,attrs:{"asset":asset}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }